import React, { useState } from "react";
import Login from "./Login";
import VerifyOtp from "../../components/verifyOtp/VerifyOtp";
import { useDispatch } from "react-redux";
import { loginAction } from "../../redux/actions/authAction";
import { useHistory } from "react-router-dom";

function LoginVerifyOtp() {

    const [showVerifyOtp, setShowVerifyOtp] = useState(false);
    const [userName, setUserName] = useState(""); // this is the username from the login page
    const dispatch = useDispatch();
    const history = useHistory();

    const onVerifyOtp = async (otp) => {
        const data = {
            userName: userName,
            otp: otp,
        };
        try {
            const res = await dispatch(loginAction(data));
            if (res?.data.login) {
                if (res?.data?.tblUser?.pwdUpdateFlag === "Y") {
                    history.push("/");
                } else {
                    history.push("/resetpassword");
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    const onLoginSuccess = (userName) => {
        setUserName(userName);
        setShowVerifyOtp(true);
    };
    return (
        <>
            {showVerifyOtp ? (
                <div className="Login__Body">
                    <div className="container_login" id="container">
                        <div className="form-container sign-in-container" style={{ backgroundColor: '#366c77' }}>
                            <div style={{ textAlign: "center" }}>
                                <VerifyOtp onVerifyOtp={onVerifyOtp} />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <Login onLoginSuccess={onLoginSuccess} />
            )}
        </>
    );
}

export default LoginVerifyOtp;
